<template>
  <action-log-template :actionLog="actionLog">
    <template #actionName>
      <p :class="['action-type flex-row flex__left inline-flex']">
        <i
          :class="['font-size__small', 'fal fa-check-circle', 'color__blue']"
        ></i>
        <span class="font-size__small no_wrap color__blue">
          &nbsp;{{ actionNameLabel || "-" }}
        </span>
      </p>
      &nbsp; đến ngày &nbsp;
      <span class="color__blue font-italic">
        {{
          deadline
            | dateFormatter({
            nullValue: "-",
            dateFormat: "DD/MM/YYYY"
          })
        }}
      </span>
    </template>
  </action-log-template>
</template>

<script>
import convertToLabelFilter from "../../../filters/convertToLabelFilter";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import ActionLogTemplate from "./action-log-template";
import dateFormatter from "../../../filters/dateFormatter";

export default {
  name: "hc-commands-dk-deadline-action-log",
  components: {ActionLogTemplate},
  props: ["actionLog"],
  filters: {
    convertToLabelFilter,
    dateFormatter
  },
  data() {
    return {
      actionNameLabel: null,
      dataJson: null,
      newHcCaseCommands: null,
      deadline: null
    };
  },
  created() {
    this.actionNameLabel = hanhChinhUtils.getActionLogActionNameLabel(
      this.actionLog.actionName
    );
    this.dataJson = JSON.parse(this.actionLog.dataJson);
    this.newHcCaseCommands = this.dataJson.newHcCaseCommands;
    this.deadline = this.newHcCaseCommands.deadline;
  },
  methods: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/hc-commands-dk-deadline-action-log.vue